<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div>
        <el-input
          v-model="objr.config_id"
          style="width:200px;margin-right:10px"
          placeholder="请输入自动创建规则id"
        />
        <el-select
          v-model="objr.status"
          style="margin-right:10px"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="time"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleDateChange"
        />
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
      </div>
      <div>
        <!-- <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button> -->
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="config_id"
        label="创建规则id"
        align="center"
        width="100"
      >
        <template scope="scope">
          <div v-if="scope.row.config_id">{{ scope.row.config_id }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="source_account_id"
        label="来源账户id"
        width="200"
        align="center"
      />
      <el-table-column
        prop="source_project_id"
        label="来源项目id"
        width="200"
        align="center"
      />
      <el-table-column
        prop="target_account_id"
        label="目标账户id"
        width="200"
        align="center"
      />
      <el-table-column
        prop="target_project_id"
        label="目标项目id"
        width="200"
        align="center"
      />

      <el-table-column
        prop="target_project_name"
        label="目标项目名称"
        width="300"
        align="center"
      />
      <el-table-column
        prop="material_num"
        label="使用素材数量"
        width="150"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="任务状态"
        align="center"
        width="170"
      >
        <template #default="scope">
          <div class="status-cell">
            <i
              v-if="scope.row.status === 1"
              class="el-icon-success"
              style="color: #67C23A; margin-right: 5px;"
            />
            <i
              v-else-if="scope.row.status === 2"
              class="el-icon-error"
              style="color: #F56C6C; margin-right: 5px;"
            />
            {{ scope.row.status_text }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fail_reason"
        label="失败原因"
        width="200"
        align="center"
      >
        <template #default="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.fail_reason"
            placement="top-start"
          >
            <div class="multi-line-ellipsis">
              {{ scope.row.fail_reason }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        width="170"
        align="center"
      />
      <el-table-column
        prop="updated_at"
        label="更新时间"
        align="center"
      />
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />

  </div>
</template>
<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { createadrecordlist } from '@/api/report/adx'
export default {
  components: {
    PaginationRight
  },
  data() {
    const today = new Date()
    const yyyy = today.getFullYear()
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const dd = String(today.getDate()).padStart(2, '0')

    const startOfMonth = `${yyyy}-${mm}-01`
    const todayStr = `${yyyy}-${mm}-${dd}`
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        config_id: '',
        status: 0,
        start_date: startOfMonth,
        end_date: todayStr
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '开启'
        },
        {
          value: 2,
          label: '关闭 '
        }
      ],
      time: [startOfMonth, todayStr] // ✅ 默认：[当月1号, 今天]
    }
  },
  created() {
    this.menuList()
  },
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await createadrecordlist(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      // this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.config_id = ''
      this.objr.status = 0
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },
    // 删除
    // async deleteItem(row) {
    //   this.$confirm('是否确定删除该条信息吗', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     closeOnClickModal: false,
    //     type: 'warning'
    //   }).then(async() => {
    //     await createadconfigdel({ id: row.id })
    //     this.menuList()
    //     this.$message({
    //       message: '删除成功',
    //       type: 'success'
    //     })
    //   })
    // },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    handleDateChange(val) {
      if (!val || val.length !== 2) return

      const [start, end] = val
      const startDate = new Date(start)
      const endDate = new Date(end)

      const sameMonth = startDate.getFullYear() === endDate.getFullYear() && startDate.getMonth() === endDate.getMonth()

      if (!sameMonth) {
        this.$message.warning('开始和结束时间必须在同一个月份')
        this.time = []
        this.objr.start_date = ''
        this.objr.end_date = ''
      } else {
        this.objr.start_date = start
        this.objr.end_date = end
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 最多两行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4em;
  max-height: 2.8em; /* 1.4em * 2 */
  word-break: break-all;
}
.status-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
